import { Component, OnInit } from "@angular/core";
import {
  faChartBar,
  faChartLine,
  faCog,
  faInfoCircle,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {
  faInfoCircle = faInfoCircle;
  faChartBar = faChartBar;
  faChartLine = faChartLine;
  faUsers = faUsers;
  faCog = faCog;
  constructor() {}

  ngOnInit(): void {
    // Inicialização do componente
  }
}
